// extracted by mini-css-extract-plugin
module.exports =  {"close":"_2787e5dfdf--close--RGTqA","content":"_2787e5dfdf--content--yLPXZ","img":"_2787e5dfdf--img--oJhxg","link":"_2787e5dfdf--link--NOVvz"};